import { inject, Injectable } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { KeycloakEventTypeLegacy, KeycloakService } from 'keycloak-angular';
import { combineLatest, filter, merge, of, switchMap, tap } from 'rxjs';
import { AuthStore } from './auth.store';
import { KeycloakAdminService } from './keycloak-admin.service';

@Injectable({ providedIn: 'root' })
export class KeycloakUserConnectService {
  #keycloak = inject(KeycloakService);
  #keycloakAdminSercice = inject(KeycloakAdminService);
  #userStore = inject(AuthStore);

  init() {
    this.#keycloakAdminSercice.keycloakService.keycloakEvents$.subscribe({
      next: event => {
        if (event.type === KeycloakEventTypeLegacy.OnTokenExpired) {
          this.#keycloakAdminSercice.keycloakService.updateToken(1800);
        }
      },
    });

    const updateUserIfLogin$ = of(this.#keycloak.isLoggedIn()).pipe(
      filter(Boolean),
      switchMap(() =>
        combineLatest([
          this.#keycloak.loadUserProfile(),
          of(this.#keycloak.getUserRoles(true) as string[]),
          // V4: pull the access token so AuthStore can decode `permissions[]` + `org_id`.
          this.#keycloak.getToken(),
        ])
      ),
      tap(async ([profile, roles, token]) => {
        this.#userStore.loadUser({ profile, roles, token });
      })
    );

    merge(updateUserIfLogin$).pipe(takeUntilDestroyed()).subscribe();
  }
}
